<template>
  <div>
    <el-header>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>发票管理</el-breadcrumb-item>
        <el-breadcrumb-item>发票申请</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <div style="background: #fff; padding-bottom: 20px">
      <div class="title_box">
        <span>发票类型</span>
      </div>
      <div style="padding: 20px">
        <el-radio-group v-model="companyInfo.invoiceCategory">
          <el-radio label="01">普票</el-radio>
          <el-radio label="02" style="margin-left: 100px">专票</el-radio>
        </el-radio-group>
        <div style="padding: 30px 0; font-weight: bold">
          普票专票均为电子发票，请按需选择
        </div>
      </div>
      <div class="title_box" style="">
        <span>发票抬头</span>
      </div>
      <el-row :gutter="20" style="padding: 0 20px 20px">
        <el-col :span="10"
          >企业名称：<span style="font-weight: bold">{{
            companyInfo.enterpriseName
          }}</span></el-col
        >
        <el-col :span="10"
          >纳税人识别码：<span style="font-weight: bold">{{
            companyInfo.taxPayerCode
          }}</span></el-col
        >
        <el-col :span="10"
          >开户行：<span style="font-weight: bold">{{
            companyInfo.bankName
          }}</span></el-col
        >
        <el-col :span="10"
          >开户账号：<span style="font-weight: bold">{{
            companyInfo.bankCode
          }}</span></el-col
        >
        <el-col :span="10"
          >地址：<span style="font-weight: bold">{{
            companyInfo.enterpriseFullRegAddr
          }}</span></el-col
        >
        <el-col :span="10"
          >单位电话：<span style="font-weight: bold">{{
            companyInfo.enterpriseTelephone
          }}</span></el-col
        >
        <el-col :span="10"
          >联系人姓名：<span style="font-weight: bold">{{
            companyInfo.applicant
          }}</span></el-col
        >
        <el-col :span="10"
          >联系人手机号：<span style="font-weight: bold">{{
            companyInfo.telephone
          }}</span></el-col
        >
        <el-col :span="10"
          >电子邮箱：<span style="font-weight: bold">{{
            companyInfo.mailbox
          }}</span></el-col
        >
        <el-col :span="10"
          >联系地址：<span style="font-weight: bold">{{
            companyInfo.applicantFullAddr
          }}</span></el-col
        >
      </el-row>
      <div
        style="
          padding-top: 20px;
          text-align: center;
          border-top: 1px solid #eee;
        "
      >
        <el-button
          style="margin-right: 50px; width: 150px"
          size="small"
          @click="resetForm"
          >取 消</el-button
        >
        <el-button
          style="width: 150px"
          size="small"
          type="primary"
          @click="submitForm"
          >确 定</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { getTitleDetail, getInvoiceAdd } from '@/api/adminData/index'
export default {
  data() {
    return {
      contentLoading: false,
      guid: '',
      companyInfo: {
        // invoiceMoney: sessionStorage.getItem('invoiceMoney'), // 发票金额
        // invoiceType: '00', // 发票开具形式 00: 系统自动开票（电子票）;01: 手工开票（电子票）
        invoiceCategory: '01', // 发票类型 01：普票；02：专票
        guaranteeIds: '', // 选择的开票保函id
        enterpriseName: '',
        taxPayerCode: '',
        bankName: '',
        bankCode: '',
        enterpriseRegAddr: '',
        enterpriseTelephone: '',
        applicant: '',
        telephone: '',
        mailbox: '',
        applicantAddr: '',
        applicantFullAddr: '',
        enterpriseFullRegAddr: ''
      }
    }
  },
  mounted() {
    this.guid = this.$route.query.guid
    this.getDetailData()
  },
  methods: {
    resetForm() {
      this.$router.go(-1)
    },
    getDetailData() {
      // 重新选择抬头
      this.contentLoading = true
      getTitleDetail({ guid: this.guid }).then((res) => {
        if (res.success) {
          let obj = Object.assign(this.companyInfo, res.result)
          this.companyInfo = obj
        }
        this.contentLoading = false
      })
    },
    submitForm() {
      //  提交
      this.contentLoading = true
      const gIds=sessionStorage.getItem('guaranteeIds')
      this.companyInfo.guaranteeIds=gIds
      getInvoiceAdd(this.companyInfo).then((res) => {
        if (res.success) {
          this.$message.success(res.message)
          setTimeout(() => {
            this.$router.go(-1)
          }, 1000)
        } else {
          // this.$message.error(res.message)
          this.$confirm(
            '申请发票失败，请联系客服人员，电话：400-895-8805',
            '提示',
            {
              confirmButtonText: '知道了',
              showCancelButton: false,
              type: 'warning'
            }
          )
        }
        this.contentLoading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.title_box {
  padding: 8px 20px;
  border-bottom: 1px solid #eee;
  font-weight: 700;
  display: flex;
  align-items: center;

  span {
    flex: 1;
  }

  button {
    float: right;
  }
}

.title_box2 {
  padding: 20px 20px;
  // border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
  font-weight: 700;
  display: flex;
  align-items: center;

  span {
    font-weight: bold;
  }

  p {
    font-weight: normal;
    padding-left: 10px;

    span {
      font-weight: bold !important;
    }
  }
}

.el-col-10 {
  padding-top: 20px;
}

i {
  color: #1890ff;
}
</style>
